import { RewardStatus } from "Shared/types/Rewards";

type TooltipRewardStatus = Exclude<RewardStatus, RewardStatus.unprocessed>

const REWARD_STATUS_DESCRIPTIONS_DICTIONARY: { [key in TooltipRewardStatus]: string} = {
  [RewardStatus.pendingApproval]: "Reward has been submitted and is waiting for approval by Secondary Approver.",
  [RewardStatus.approved]: "Reward has been approved by secondary approver.",
  [RewardStatus.rejected]: "Secondary Approver rejected the reward to this employee.",
  [RewardStatus.paid]: "Secondary Approver approved this reward and the employee received the payment.",
  [RewardStatus.withheld]: "Reward has been claimed by employee, but the payment failed to send to their account.",
};

export const REWARD_STATUS_DESCRIPTIONS = Object
  .entries(REWARD_STATUS_DESCRIPTIONS_DICTIONARY)
  .map(([status, description]) => ({ status, description }));
